import type {DefaultMantineColor} from '@mantine/core';
import {Badge} from '@mantine/core';
import {STATE_COLOR_SHADES} from 'src/design/tokens/colors';
import type {StateColor} from 'src/design/tokens/colors';

/**
 * Small colored status badge with deliberate green/yellow/red/blue color
 * overrides for better contrast.
 * @registry Colored status badge (green/yellow/red/blue get contrast-adjusted shades).
 *
 * Ported from `library-m/data-display/Pill`. Prop surface kept identical.
 */
export interface PillProps {
  text: string;
  color?: DefaultMantineColor;
}

export const Pill = ({text, color}: PillProps) => {
  const override =
    color && color in STATE_COLOR_SHADES
      ? STATE_COLOR_SHADES[color as StateColor]
      : color;
  return (
    <Badge mr="sm" color={override} size="md" p="xs" autoContrast={false}>
      {text}
    </Badge>
  );
};
